import React from 'react'
import styled from 'styled-components'
import { Footer } from './components/Footer/Footer'
import { Navbar } from './components/Navbar/Navbar'
import { Router } from './routes/Router'

const PageContainer = styled.div`
  height: calc(100vh - 80px);
  position: absolute;
  top: 80px;
  width: 100%;
`
function App() {
  return (
    <div className="App min-vh-100">
      <Navbar />
      <PageContainer>
        <Router />
        <Footer />
      </PageContainer>
    </div>
  )
}

export default App
